var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.8075 0.541661L36.4544 17.1918C37.6197 18.3574 36.7948 20.3498 35.1467 20.3498H33.2971V31.4499C33.2971 32.9219 32.7124 34.3336 31.6718 35.3744C30.6312 36.4153 29.2198 37 27.7481 37H25.8984V24.0499C25.8985 22.6342 25.3577 21.272 24.3867 20.242C23.4157 19.212 22.0879 18.5921 20.675 18.5091L20.3495 18.4998H16.6501C15.1785 18.4998 13.7671 19.0845 12.7264 20.1254C11.6858 21.1662 11.1012 22.5779 11.1012 24.0499V37H9.25152C7.77984 37 6.36844 36.4153 5.3278 35.3744C4.28717 34.3336 3.70255 32.9219 3.70255 31.4499V20.3498H1.85289C0.206695 20.3498 -0.620102 18.3574 0.545182 17.1918L17.1921 0.541661C17.539 0.194835 18.0093 0 18.4998 0C18.9903 0 19.4606 0.194835 19.8075 0.541661ZM20.3495 22.1998C20.84 22.1998 21.3105 22.3948 21.6574 22.7417C22.0042 23.0886 22.1991 23.5592 22.1991 24.0499V37H14.8005V24.0499C14.8005 23.5967 14.9669 23.1594 15.2679 22.8208C15.569 22.4821 15.9838 22.2658 16.4337 22.2128L16.6501 22.1998H20.3495Z",
    fill: "#224366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.6bb26e38ee060166d391a36b5a180d98.svg";
export { ForwardRef as ReactComponent };